import { useMemo } from 'react';
import { StyledCoreDropdown, ViewModePropertyContainer } from './PropertyDropdown.styled';
import Properties from './properties';
// import { Property } from './types';
import { getPropertiesForDropdown } from './utils';

// type Props = {
//   /** Additional classes. */
//   className: string,
//   /** Array of properties to hide. */
//   hiddenProperties: Array<string>,
//   /** Array of properties to disable. */
//   disabledProperties: Array<string>,
//   /** If query builder is in view mode. */
//   isViewMode: boolean,
//   /** If query builder is in read only mode. */
//   isReadOnly?: boolean,
//   /** Placeholder for property dropdown. */
//   placeholder: 'string',
//   /** List of properties. */
//   properties: [Property],
//   /** The currently selected property. */
//   value: string,
//   /** Filters to these properties if specified. */
//   restrictToProperties?: Array<string>,
// };

const PropertyDropdown = ({
  className,
  hiddenPropertySections,
  hiddenProperties,
  disabledProperties,
  isViewMode = false,
  isReadOnly = false,
  placeholder,
  properties = Properties,
  value,
  isMatchTriggeringEventFields,
  restrictToProperties = [],
  ...otherProps
}) => {
  const shouldRestrictToProperties = !!restrictToProperties && restrictToProperties?.length > 0; // can't restrict to nothing!
  const filteredProperties = useMemo(
    () =>
      getPropertiesForDropdown({
        hiddenPropertySections,
        hidden: hiddenProperties,
        disabled: disabledProperties,
        restrictTo: restrictToProperties,
        properties,
        shouldRestrict: shouldRestrictToProperties,
      }),
    [
      hiddenProperties,
      disabledProperties,
      restrictToProperties,
      properties,
      hiddenPropertySections,
    ],
  );

  const valueIsInProperties = useMemo(
    () => (shouldRestrictToProperties ? filteredProperties?.some((p) => p.value === value) : true),
    [shouldRestrictToProperties, filteredProperties, value],
  );

  const propertyPlaceholder = useMemo(
    () => (shouldRestrictToProperties ? properties?.find((p) => p.value === value)?.text : ''),
    [shouldRestrictToProperties, properties],
  );

  return isViewMode ? (
    <ViewModePropertyContainer data-test="query-builder-property-view-mode">
      {value}
    </ViewModePropertyContainer>
  ) : (
    <StyledCoreDropdown
      disabled={isReadOnly}
      searchInput={{ autoComplete: 'chrome-off' }}
      data-test="query-builder-property-dropdown"
      fluid
      options={filteredProperties}
      placeholder={propertyPlaceholder || placeholder}
      search
      value={value}
      isError={value && !valueIsInProperties}
      {...otherProps}
    />
  );
};

export default PropertyDropdown;
